import { Store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";

export const notify= (title = "", type = "success", desc = " ") => {
  if (type == 'error') type = 'danger';
  switch (type) {
    case "snack":
      // rootStore.toast.text = title;
      // rootStore.toast.visible = true;
      break;
    default:
      Store.addNotification({
        title: title,
        message: desc,
        type: type,
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: false,
          showIcon: true,
        },
      });
      break;
  }
}

export const dateFormat = (isoDate) => {
  const date = new Date(isoDate);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};
const options = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};
export const DateStringFormat = (sdate) => {
  const date = new Date(sdate);
  const formattedDate = date.toLocaleDateString("en-IN", options);
  return formattedDate;
};

// export const formatTime = (sldate) => {
//   let date = new Date(sldate)
//   const hours = date?.getHours();
//   const minutes = date?.getMinutes();
//   const ampm = hours >= 12 ? 'PM' : 'AM';
//   const formattedHours = hours % 12 || 12; // 12-hour format, converts 0 (midnight) to 12
//   const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes; // Adds leading zero for single-digit minutes
//   return `${formattedHours}:${formattedMinutes} ${ampm}`;
// };

export const convertTo24HourFormat = (time) => {
  const [timePart, modifier] = time.split(" ");
  let [hours, minutes] = timePart.split(":").map(Number);
  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  } else if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
};

export const formatTime = (time24) => {
  const [hours, minutes] = time24?.split(":").map(Number);
  const period = hours >= 12 ? "PM" : "AM";
  const adjustedHours = hours % 12 || 12;
  const formattedHours = adjustedHours.toString().padStart(2, "0");

  return `${formattedHours}:${minutes.toString().padStart(2, "0")} ${period}`;
};

export const getCurrentMonthEnd = () => {
  const currentDate = new Date(); // Get current date
  const currentMonth = currentDate.getMonth(); // Get the current month (0-based index)
  const currentYear = currentDate.getFullYear(); // Get the current year

  // Create a new date object set to the first day of the next month
  const nextMonth = new Date(currentYear, currentMonth + 1, 0); // 0 means the last day of the previous month

  return nextMonth; // This will give us the last day of the current month
};

export const getLastDateOfCurrentMonth = (date) => {
  const currentDate = date; // Get current date
  const currentMonth = currentDate.getMonth(); // Get current month (0-based index)
  const nextMonth = currentMonth + 1; // Next month

  // Set the date to the first day of the next month
  const lastDateOfCurrentMonth = new Date(
    currentDate.getFullYear(),
    nextMonth,
    0
  );

  return lastDateOfCurrentMonth;
};
